// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSEllipsis/index.less
// module id = 1048
// module chunks = 42